export class EmployeeBuyerMappingModels{
    id: number;
    buyerId?:number
    employeeId?:number
    employeeName?: string;
    buyerName?:string;
    
    // createdUser:string;
    
    
   updatedUser?:string

    constructor(id: number,buyerId?:number,
      employeeId?:number,employeeName?: string,buyerName?:string,
        //isActive: boolean,versionFlag: number, 
        
        updatedUser?:string){
        this.id = id
        this.buyerId=buyerId
        this.employeeId=employeeId
        this.employeeName = employeeName
        this.buyerName=buyerName
        // this.isActive = isActive
        // this.versionFlag = versionFlag
      //  this.createdUser=createdUser
        this.updatedUser=updatedUser
        
    }
}